<template>
  <div class="module-title" :style="titleStype">
    <div class="title" :style="{ color: titleColor, fontSize: fontSize }">
      {{ title }}
    </div>
    <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
    <div class="title-tips" :style="descStype">
      <div
        class="tips-item"
        v-for="(item, index) in moduleTipsList"
        :key="index"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: "transparent",
    },
    moduleTipsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "32px",
    },
    titleColor: {
      type: String,
      default: "#333",
    },
    descStype: {
      type: Object,
      default: () => {
        return {};
      },
    },
    titleStype: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
<style lang="less" scoped>
.module-title {
  text-align: center;
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  margin-bottom: 50px;
}
.title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  margin-bottom: 14px;
}
.sub-title {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
}
</style>
